import React from 'react';

import { useTranslation } from 'react-i18next';

import { commentReply } from "state/detailedposting/actions";
import { useDispatcher } from "ui/hook";
import { Icon, msReplySolid } from "ui/material-symbols";

interface Props {
    id: string;
    ownerName: string;
    ownerFullName: string | null;
    ownerSourceUri: string | null;
    heading: string;
}

export default function CommentReplyButton({id, ownerName, ownerFullName, ownerSourceUri, heading}: Props) {
    const dispatch = useDispatcher();
    const {t} = useTranslation();

    const onClick = () => dispatch(commentReply(id, ownerName, ownerFullName, ownerSourceUri, heading));

    return (
        <button className="comment-button" onClick={onClick}>
            <Icon icon={msReplySolid} size="1.2em"/>
            <span className="caption">{t("reply")}</span>
        </button>
    );
}
